import StarIcon from '@mui/icons-material/Star';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';

import { neutral, yellow } from '../../../styles/mui/colors';

const reviewStarsStyle = {
  wrapper: {},
  icon: { color: yellow.main },
};

// averageReview and reviewCount can be null because of legacy listings
const ReviewStarsComponent = ({ averageReview = null, reviewCount = null }) => {
  if (!reviewCount || !averageReview) return null;
  return (
    <Stack alignItems="center" direction="row" justifyContent="center" spacing={1} sx={reviewStarsStyle.wrapper}>
      <StarIcon sx={reviewStarsStyle.icon} />
      <Typography margin={0} sx={{ color: neutral[500] }} variant="body2">
        {`${averageReview.toFixed(1)} (${reviewCount})`}
      </Typography>
    </Stack>
  );
};

const ReviewStars = memo(ReviewStarsComponent);
ReviewStars.displayName = 'ReviewStars';

export default ReviewStars;
